class VwStkDepodonemDTO {
    id: number = null;
    depoTanimId?: number = null;
    organizasyonId?: number = null;
    depoAdi?: string = "";
    bagliOrganizasyonId?: number = null;
    donemYil?: number = null;
    donemBaslangicTarih?: string = null;
    donemBitisTarih?: string = null;
    donemAktif?: string = "";
    depoTipId?: number = null;
    depoTip?: string = "";
    tanimHastaCikisYapar?: string = "E";
    tanimServisCikisYapar?: string = "E";
    tanimDepoCikisYapar?: string = "E";
    tanimDigerCikisYapar?: string = "E";
    tanimAktif?: string = "";
}
export default VwStkDepodonemDTO;